import { render } from "./CarouselForm.vue?vue&type=template&id=602fb5fb&scoped=true&ts=true"
import script from "./CarouselForm.ts?vue&type=script&lang=ts"
export * from "./CarouselForm.ts?vue&type=script&lang=ts"

import "./CarouselForm.scss?vue&type=style&index=0&id=602fb5fb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602fb5fb"]])

export default __exports__